import { Page } from 'layouts/Page';
import { FC } from 'react';
import { PaymentMethods } from 'components/PaymentMethods';

export const PaymentMethodsPage: FC = () => {
	return (
		<Page title="Payment Methods – EAS Dashboard">
			<PaymentMethods />
		</Page>
	);
};
